<template>
  <form @submit.prevent='submit' :class='{"loading": loading}'>
    <x-errors-messages :errors='errors'></x-errors-messages>
    <slot :loading="loading" />
  </form>
</template>

<script>
  import xErrorsMessages from '@/components/controls/x-errors-messages'

  export default {
    name: 'x-form',
    props: ['request', 'requestErrors'],
    methods: {
      submit (event) {
        this.$emit('submit', event)
      }
    },
    data () {
      return {
        loading: false,
        errors: []
      }
    },
    watch: {
      request () {
        this.loading = true
        this.request.then(() => {
          this.loading = false
        })
          .catch(({ fields }) => {
            this.loading = false
            this.errors = fields.global
          })
      },
      requestErrors () {
        this.errors = this.requestErrors
      }
    },
    components: {
      'x-errors-messages': xErrorsMessages
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  form {
    transition: padding-bottom 400ms;
    &.changed {
      padding-bottom: $space-big;

      @media screen and (max-width: $md-breakpoint) {
        padding-bottom: $space-big * 2;
      }
    }
    &.loading {
      input, select, textarea, .button {
        pointer-events: none;
        opacity: 0.8;
      }
    }
  }
</style>
